export const caseInsensitiveIncludes = (word: string, searchString: string): boolean => {
  return word.toLowerCase().includes(searchString.toLowerCase());
};

export const convertExpressionToRegexString = (exp: string): string => {
  return exp
    .replace(/[-[\]{}()+?,\\^$|#*]/g, "\\$&") // escape special characters except .
    .replace(/ +/g, ".*");
};

export const includesRegularExpression = (word: string, regexStr: string): boolean => {
  return new RegExp(regexStr, "gi").test(word);
};
